import { useState, useEffect } from 'react';
import { TopToolbar, AutocompleteInput, useRecordContext, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';
import CatalogProductModalCreate from "../components/catalogProductCreate";
import {ProductFamilyText} from "../components/productFamilyText";

const ListActions = (props) => (
    <TopToolbar>
        <CatalogProductModalCreate />
        <ExportButton/>
    </TopToolbar>
);

export const CatalogProductList = (props) => {
    var record = useRecordContext();
    if (!record || !record.id) return <span>Chargement</span>;
    var catalogId = record.id;

    return (
        <>
            <List exporter={false} style={{width: "100%"}} filter={{ catalogId: catalogId }} resource="catalogProducts" basePath="" actions={<ListActions catalogId={catalogId}/>}>
                <Datagrid>
                    <TextField source="productId" label="ID Produit" />
                    <ProductFamilyText label="Catégorie" />
                    <ReferenceField source="productId" reference="products" label="Nom du produit">
                        <TextField source="product" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Détails">
                        <TextField source="details" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Prix TTC">
                        <TextField source="price" />
                    </ReferenceField>
                </Datagrid>
            </List>
            <CatalogProductModalCreate />
        </>
    )
};